import { MediaManagerTemplate } from 'modules/core/domain/interfaces/supabase/media-manager/entity';
import supabase from 'modules/core/supabase/supabase';
import { useCallback, useState } from 'react';
import { UDButton } from 'ud-ui/components';
import Modal from 'ud-ui/components/modal';

interface Args {
  onDeleted: () => void;
}

function useDeleteTemplateModal({ onDeleted }: Args) {
  const [template, setTemplate] = useState<MediaManagerTemplate | null>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const open = useCallback((next: MediaManagerTemplate) => {
    setTemplate(next);
    setIsOpen(true);
  }, []);
  const close = useCallback(() => setIsOpen(false), []);

  const onSubmit = useCallback(async () => {
    if (!template) return;
    setIsLoading(true);
    try {
      await supabase.mediaManager.deleteTemplate(template.id);
      onDeleted();
      close();
    } catch (error) {
      console.error('Failed to delete media manager template:', error);
    } finally {
      setIsLoading(false);
    }
  }, [template, onDeleted, close]);

  return {
    open,
    close,
    modal: (
      <Modal show={isOpen} onClose={close}>
        <Modal.Header
          title="Удаление шаблона"
          subtitle={`Вы уверены, что хотите удалить "${template?.name ?? 'Неизвестное'}" шаблон?\nЭто действие нельзя отменить.`}
          className={'w-[450px]'}
        />
        <Modal.Footer>
          <UDButton variant="secondary" type="button" onClick={close} loading={isLoading} stretch>
            Отмена
          </UDButton>
          <UDButton variant="primary" type="button" onClick={onSubmit} loading={isLoading} stretch>
            Удалить
          </UDButton>
        </Modal.Footer>
      </Modal>
    ),
  };
}

export default useDeleteTemplateModal;
